import React from 'react'
import { Link } from 'react-router-dom'
import { Status } from '@LTIDashboard/modules/common'
import { Title } from '@LTIDashboard/modules/GeneralDashboard/Assessments/Assessment/Title'

export function Assessment({ data }) {
  if (!data) return null
  let params = window.location.pathname.split('/')
  const courseNumber = params[3]
  return (
    <Link
      to={{
        pathname: `/instructor/lti_dashboard/${courseNumber}/${data.pk}`,
      }}
      style={{ textDecoration: 'none' }}
    >
      <button className="btn-block border rounded mb-1 px-4">
        <div className="d-flex justify-content-between align-items-center my-3">
          <Title title={data.title} />
          <div id="assessment-status">
            {data.individualStatusItems.map(item => (
              <Status key={item.text} item={item} />
            ))}
          </div>
        </div>
      </button>
    </Link>
  )
}
